// extracted by mini-css-extract-plugin
export default {"main":"main__nEl8aK0u"};